module.exports = __webpack_public_path__ + "static/img/title.2465c91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-1/title.png
// module id = BQZt
// module chunks = 0